import { FuelGasUnitOperation } from './fuel-gas-unit-operation';
import { DistributionRatioVariable } from '../distribution-ratio-variable';
import { isTypeUndefined } from '../../../_utils/utils';
import { SuncorMaterialStream } from '../../_streams/suncor-material-stream';

export abstract class BaseFuelGasSplitter extends FuelGasUnitOperation {
  abstract override category: string;

  isOptimizable: boolean;
  distributionRatioVariables: DistributionRatioVariable[] = [];

  override initValues(unitOperation: BaseFuelGasSplitter | any) {
    super.initValues(unitOperation);

    this.isOptimizable = isTypeUndefined(unitOperation.isOptimizable) ? false : unitOperation.isOptimizable;
    if (unitOperation.distributionRatioVariables instanceof Array) {
      for (const dv of unitOperation.distributionRatioVariables) {
        this.distributionRatioVariables.push(new DistributionRatioVariable(dv.unitOperationId, dv.value));
      }
    }
  }

  addDistributionVariable(unitOperationId: string) {
    this.emptyDistributionValues();
    this.distributionRatioVariables.push(new DistributionRatioVariable(unitOperationId, null));
  }

  private emptyDistributionValues() {
    for (const dv of this.distributionRatioVariables) {
      dv.value = null;
    }
  }

  findDistributionRatioVariable(unitOperationId: string): DistributionRatioVariable {
    return this.distributionRatioVariables.find(drv => {
      return drv.unitOperationId === unitOperationId;
    });
  }

  findDistributionRatioVariableName(i: number): string {
    const dv = this.distributionRatioVariables[i];

    if (dv) {
      const uo = this.ownerCase.getUnitOperation(dv.unitOperationId);

      const streams = this.ownerCase.filterAllMaterialStreams((ms: SuncorMaterialStream) => {
        return ms.outletUnitOperationId === uo?.id;
      });

      return streams.length ? streams[0].outletUnitOperation.name : undefined;
    }

    return undefined;
  }

  findDistributionRatioVariableIndex(unitOperationId: string) {
    return this.distributionRatioVariables.indexOf(this.findDistributionRatioVariable(unitOperationId));
  }

  removeDistributionRatioVariable(unitOperationId: string): void {
    const index = this.findDistributionRatioVariableIndex(unitOperationId);

    if (index >= 0) {
      this.distributionRatioVariables.splice(index, 1);
    }
  }
}
